<template>
  <v-container>
      <!--<h1 class="mb-5">{{ title }}</h1>-->
      
      <product-selector :id="$route.params.id" :full-view="true" v-if="product" />
  </v-container>
</template>

<script>
import products from "@/services/products";
import ProductSelector from "@/components/products/ProductSelector.vue";

export default {
    name: 'Products',
    created() {
        if (!this.product)
            this.$router.replace("/");
    },
    computed: {
        product() {
            return products.get(this.$route.params.id);
        },
        title() {
            const p = this.product;

            return p ? p.name : null;
        }
    },
    components: { ProductSelector },
};
</script>